"use client"

import Link from "next/link"

interface RouteErrorStateProps {
  error: Error & { digest?: string }
  reset: () => void
  title: string
  description: string
}

export const RouteErrorState = ({
  error,
  reset,
  title,
  description,
}: RouteErrorStateProps): React.ReactNode => {
  return (
    <main className='mx-auto flex min-h-[60vh] w-full max-w-4xl flex-col items-center justify-center gap-6 p-6 text-center'>
      <div className='space-y-2'>
        <h1 className='font-semibold text-2xl text-gray-900'>{title}</h1>
        <p className='text-gray-600 text-sm'>{description}</p>
        {error.digest ? (
          <p className='text-gray-400 text-xs'>Ref: {error.digest}</p>
        ) : null}
      </div>

      <div className='flex items-center gap-3'>
        <button
          className='rounded-md bg-primary px-4 py-2 font-medium text-white transition hover:bg-primary/90'
          onClick={reset}
          type='button'
        >
          Tentar novamente
        </button>
        <Link
          className='rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 transition hover:bg-gray-50'
          href='/'
        >
          Ir para a pagina inicial
        </Link>
      </div>
    </main>
  )
}
